import axiosClient from '../axiosClient';
import store from '../store';
import i18n from '../i18n';

const auth = {
  async login(credentials) {
    try {
      const response = await axiosClient.post('/auth/login', credentials);
      const token = response.data?.data?.token;
      const username = response.data?.data?.username;
      const userid = response.data?.data?.userid;
      const role = response.data?.data?.role;

      if (!token || !username || !userid || !role) throw new Error("auth.token_or_user_missing");

      store.dispatch("auth/login", {
        user: {
          username,
          userid,
          role: { name: role },
        },
        token,
      });

      return {
        success: response.data.success,
        message: response.data.message,
        translatedMessage: i18n.global.t(response.data.message),
        data: response.data.data,
      };
    } catch (error) {
      const message = error.response?.data?.message || "auth.login_failed";
      return Promise.reject({
        success: false,
        message,
        translatedMessage: i18n.global.t(message),
        data: null,
      });
    }
  },

  async register(userData) {
    try {
      const response = await axiosClient.post('/auth/register', userData);
      const token = response.data?.data?.token;
      const username = response.data?.data?.username;

      if (!token || !username) throw new Error("auth.token_or_user_missing");

      const user = { username };
      store.dispatch("auth/login", { user, token });

      return {
        success: response.data.success,
        message: response.data.message,
        translatedMessage: i18n.global.t(response.data.message),
        data: response.data.data,
      };
    } catch (error) {
      const message = error.response?.data?.message || "auth.register_failed";
      return Promise.reject({
        success: false,
        message,
        translatedMessage: i18n.global.t(message),
        data: null,
      });
    }
  },

  async logout() {
    try {
      await axiosClient.post('/auth/logout');
      store.dispatch("auth/logout");

      return {
        success: true,
        message: 'auth.logout_success',
        translatedMessage: i18n.global.t('auth.logout_success'),
        data: null,
      };
    } catch (error) {
      const message = error.response?.data?.message || "auth.logout_failed";
      return Promise.reject({
        success: false,
        message,
        translatedMessage: i18n.global.t(message),
        data: null,
      });
    }
  }
};

export default auth;
